const defaultVideoA11yLabels = {
  play: 'Play',
  pause: 'Pause',
  mute: 'Mute',
  unmute: 'Unmute',
  video: 'Video',
  accessVideo: 'Access video',
};

const defaultPlaylistA11yLabels = {
  ...defaultVideoA11yLabels,
};

export const tagging = {
  taggingId: {
    type: String,
    required: true,
  },
};

export const video = {
  headingLevel: {
    type: Number,
    default: 3,
  },
  heading: {
    type: String,
    default: null,
  },
  text: {
    type: String,
    default: null,
  },
  ctalink: {
    type: String,
    default: null,
  },
  ctatext: {
    type: String,
    default: null,
  },
  alignment: {
    type: String,
    default: 'center',
  },
  loop: {
    type: Boolean,
    default: false,
  },
  autoplay: {
    type: Boolean,
    default: false,
  },
  muted: {
    type: Boolean,
    default: true,
  },
  /**
   * Sample source
   * {
   *   src: 'assets/video1.mp4',
   *   type: 'video/mp4',
   *   screenSize: 'sm',
   * }
   * Where screensizes are: sm (360p) | md (720p) | lg (1080p+)
   * NB: at present size entries MUST BE IN ASCENDING ORDER
   */
  sources: {
    validator(value) {
      return (
        Array.isArray(value) &&
        value.every((source) => ['src', 'type', 'screenSize'].every((key) => key in source))
      );
    },
  },
  controls: {
    type: Boolean,
    default: false,
  },
  poster: {
    type: String,
    default: '',
  },
  highContrastTextEnabled: {
    type: Boolean,
    default: true,
  },
  a11yLabels: {
    type: Object,
    default: () => defaultVideoA11yLabels,
  },
  transcript: {
    type: Object,
    default: () => ({}),
  },
  youtubeId: {
    type: String,
    default: '',
  },
};

export const playlist = {
  index: {
    type: String,
    default: null,
  },
  showVideoNumber: {
    type: Boolean,
    default: false,
  },
  autoplay: {
    type: Boolean,
    default: false,
  },
  aspectRatio: {
    type: String,
    default: '16-9',
    validator(value) {
      return ['16-9', '9-16', '4-5', '1-1'].includes(value);
    },
  },
  nowShowingLabel: {
    type: String,
    default: null,
  },
  titleLabel: {
    type: String,
    default: null,
  },
  muted: {
    type: Boolean,
    default: true,
  },
  a11yLabels: {
    type: Object,
    default: () => defaultPlaylistA11yLabels,
  },
  items: {
    required: true,
    validator(value) {
      return (
        Array.isArray(value) &&
        value.every((source) =>
          [
            'index',
            'title',
            'description',
            'largeThumbnailImage',
            'smallThumbnailImage',
            'cta',
            'youtubeId',
            'internalVideoId',
            'highContrastTextEnabled',
          ].every((key) => key in source),
        )
      );
    },
  },
};
